<script setup>
import { ref, computed, watch, nextTick, getCurrentInstance } from 'vue';

const props = defineProps({
    fileId: Number,
    sizes: String,
    alt: String,
    onClick: Function,
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const picture = ref(null);
const types = ref({
    //'image/webp': 'webp',
});
const show = ref(false);
const file = ref(null);

// --- Computed ---

const widths = computed(() => {
    if (file.value && picture.value) {
        let pictureWidth = picture.value.clientWidth;
        let result = [];
        for (let i = 100; i <= file.value.width; i += 100) {
            // Avoid small images being stretched
            if (i >= pictureWidth) {
                result.push(i);
            }
        }
        return result;
    }
    return [];
});

const src = computed(() => {
    return file.value ? store.getters.cdnSrc(file.value.fileName) : '';
});

// --- Methods ---

const getSrcset = (format) => {
    let srcs = [];

    widths.value.forEach((width) => {
        let s = store.getters.imageWidthSrc(
            file.value.fileName,
            file.value.width,
            file.value.modifiedDate,
            width
        );
        s += ' ' + width + 'w';
        srcs.push(s);
    });

    let lastWidth = widths.value[widths.value.length - 1];
    if (lastWidth && lastWidth < file.value.width) {
        let nextWidth = lastWidth + 100;
        let s = store.getters.fileSrc(file.value.fileName);
        s += ' ' + nextWidth + 'w';
        srcs.push(s);
    }

    nextTick(() => {
        show.value = true;
    });

    return srcs.join(',');
};

const setHeight = () => {
    if (picture.value) {
        picture.value.style.maxHeight = picture.value.clientWidth + 'px';
    }
};

const fetchFileData = (id) => {
    if (!id) {
        file.value = null;
        return;
    }

    store.dispatch('itemData/get', {
            tableName: 'files',
            id: id
        })
        .then((obj) => {
            file.value = obj;
            nextTick(() => {
                setHeight();
            });
        });
};

// --- Watchers ---

// Replacing asyncComputed with a standard watcher
watch(() => props.fileId, (newId) => {
    fetchFileData(newId);
}, { immediate: true });

</script>

<template>
    <picture ref="picture">
        <source v-if="file" :sizes="sizes" :srcset="getSrcset()">

        <source
            v-for="(format, mimeType) in types"
            v-if="file"
            :key="format"
            :sizes="sizes"
            :srcset="getSrcset(format)"
            :type="mimeType"
        >

        <img v-if="show" :alt="alt" :src="src" @click.prevent.stop="onClick">
    </picture>
</template>

<style scoped>
picture {
    display: flex;
    align-items: center;
    height: 100%;
    overflow: hidden;
    justify-content: center;
}

img {
    max-width: 100%;
}
</style>